<!-- Vertical layout -->
@if (currentLayout === 'vertical') {
  <app-scrollbar [customStyle]="'100%'">
    <div class="navbar-content">
      <ul class="nav coded-inner-navbar" (click)="fireOutClick()" (mouseleave)="navMob()">
        @for (item of navigations; track item) {
          @if (item.type === 'collapse') {
            <app-nav-collapse [item]="item" />
          } @else if (item.type === 'item') {
            <app-nav-item [item]="item" />
          }
        }
      </ul>
    </div>
  </app-scrollbar>
} @else if (currentLayout === 'horizontal') {
  <div class="navbar-content sidenav-horizontal" id="layout-sidenav">
    <a href="javascript:" class="sidenav-horizontal-prev" [ngClass]="prevDisabled" (click)="scrollMinus()"></a>
    <div #navbarWrapper class="sidenav-horizontal-wrapper">
      <ul
        #navbarContent
        id="side-nav-horizontal"
        class="nav coded-inner-navbar sidenav-inner"
        (click)="fireLeave()"
        (mouseleave)="fireLeave()"
      >
        @for (item of navigations; track item) {
          @if (item.type === 'collapse') {
            <app-nav-collapse [item]="item" />
          } @else if (item.type === 'item') {
            <app-nav-item [item]="item" />
          }
        }
      </ul>
    </div>
    <a href="javascript:" class="sidenav-horizontal-next" [ngClass]="nextDisabled" (click)="scrollPlus()"></a>
  </div>
}

<!-- Compact Layout -->
<div class="navbar-content">
  @if (currentLayout === 'compact') {
    <app-scrollbar [customStyle]="'100%'">
      <ul class="nav coded-inner-navbar" (click)="fireOutClick()" (mouseleave)="navMob()">
        @for (item of navigations; track item) {
          @if (item.type === 'collapse') {
            <app-nav-collapse [item]="item" (showCollapseItem)="subMenuCollapse($event)" />
          } @else if (item.type === 'item') {
            <app-nav-item [item]="item" />
          }
        }
      </ul>
    </app-scrollbar>
  }
</div>
@if (currentLayout === 'compact') {
  <div class="pc-compact-submenu">
    <div class="collapse-item">
      <app-scrollbar [customStyle]="'calc(var(--vh100, 100vh) - 144px)'">
        @for (item of collapseItem; track item) {
          @if (item.type === 'collapse') {
            <app-nav-collapse [item]="item" [parentRole]="item.role && item.role.length > 0 ? item.role : parentRole" />
          } @else if (item.type === 'item') {
            <app-nav-item [item]="item" />
          }
        }
      </app-scrollbar>
    </div>
  </div>
}
